import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ListKeyManagerOption } from '@angular/cdk/a11y';
import { CarouselSlide } from '../models/CarouselSlide.interface';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'lib-carousel-slide',
  templateUrl: './carousel-slide.component.html',
  styleUrl: './carousel-slide.component.scss',
})
export class CarouselSlideComponent
  implements ListKeyManagerOption, CarouselSlide, OnInit
{
  @Input() public image: SafeStyle;
  @Input() public overlayColor = '#00000040';
  @Input() public hideOverlay = false;
  @Input() public disabled = false; // implements ListKeyManagerOption

  @ViewChild(TemplateRef) public templateRef: TemplateRef<any>;

  constructor(public sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    if (this.image) {
      this.image = this.sanitizer.bypassSecurityTrustStyle(
        `url("${this.image}")`
      );
    }
  }
}
